<template>
  <div class="product-list">
    <!--搜索表单-->
    <div class="common-seach-wrap">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="使用中" name="sell">
          <span slot="label">使用中 <el-tag size="mini">{{ productCount.sell }}</el-tag></span>
        </el-tab-pane>
        <el-tab-pane label="仓库中" name="lower">
          <span slot="label">仓库中 <el-tag size="mini">{{productCount.lower}}</el-tag></span>
        </el-tab-pane>
        <el-tab-pane label="回收站" name="recovery">
          <span slot="label">回收站 <el-tag size="mini">{{productCount.recovery}}</el-tag></span>
        </el-tab-pane>
      </el-tabs>
      <el-form size="small" :inline="true" :model="searchForm" class="demo-form-inline">
        <el-form-item label="设备分类">
          <el-select size="small" v-model="searchForm.categoryId" placeholder="所有分类">
            <el-option label="全部" value="0"></el-option>
            <el-option v-for="(item, index) in categoryList" :key="index" :label="item.name"
                       :value="item.categoryId"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="设备名称">
          <el-input size="small" v-model="searchForm.productName" placeholder="请输入设备名称"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button size="small" type="primary" icon="el-icon-search" @click="onSubmit">查询</el-button>
        </el-form-item>
      </el-form>
    </div>
    <!--内容-->
    <div class="product-content">
      <div class="table-wrap">
        <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading">
          <el-table-column prop="productName" label="产品" width="400px">
            <template slot-scope="scope">
              <div class="product-info">
                <div class="pic"><img v-img-url="scope.row.imagePath" alt=""/></div>
                <div class="info">
                  <div class="number">{{ scope.row.number }}</div>
                  <div class="name">{{ scope.row.name }}</div>
                  <div class="price">
                    <el-tag type="success" v-if="scope.row.state === 'online'">在线</el-tag>
                    <el-tag type="info" v-else-if="scope.row.state === 'notActive'">未激活</el-tag>
                    <el-tag type="danger" v-else>离线</el-tag>
                  </div>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="商户" width="180">
            <template slot-scope="scope">
              <div  class="payment-info-cell">
                <el-tooltip effect="light" placement="top">
                  <div slot="content" class="payment-tooltip">
                    <div class="tooltip-item">
                      <span class="label">名称：</span>
                      <span class="value">{{ scope.row.shopSupplierName || '-' }}</span>
                    </div>
                    <div class="tooltip-item">
                      <span class="label">手机：</span>
                      <span class="value">{{ scope.row.shopSupplierPhone || '-' }}</span>
                    </div>
                  </div>

                  <div class="payment-brief">
                    <el-tag size="mini" type="info">
                      名称: {{ scope.row.shopSupplierName || '-' }}
                    </el-tag>
                    <el-tag size="mini" type="info" style="margin: 2px 0">
                      手机: {{ scope.row.shopSupplierPhone || '-' }}
                    </el-tag>
                  </div>
                </el-tooltip>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="productName" label="产品类型" width="140" show-overflow-tooltip></el-table-column>
          <el-table-column prop="salesActual" label="实际销量"></el-table-column>
          <el-table-column prop="modelName" label="型号"></el-table-column>
          <el-table-column prop="storeVo.storeName" label="所在门店" width="140" show-overflow-tooltip></el-table-column>
          <el-table-column prop="simIccid" label="卡号"></el-table-column>
          <el-table-column prop="address" label="ip地址" width="110"></el-table-column>
          <el-table-column prop="onlineTime" label="上线时间" width="140"></el-table-column>
          <el-table-column prop="offlineTime" label="离线时间" width="140"></el-table-column>
          <el-table-column prop="createTime" label="发布时间" width="140"></el-table-column>
          <el-table-column prop="productSort" label="排序"></el-table-column>
          <el-table-column fixed="right" label="操作" width="80">
          <template slot-scope="scope">
            <div class="table-btn-column">
              <el-button v-if="scope.row.auditStatus==10" @click="editClick(scope.row)" type="text" size="small"
                         v-auth="'/product/product/edit'">编辑
              </el-button>
              <el-button v-if="scope.row.auditStatus==0" @click="editClick(scope.row)" type="text" size="small"
                         v-auth="'/product/product/edit'">审核
              </el-button>
              <el-button @click="delClick(scope.row)" type="text" size="small" v-auth="'/product/product/delete'">删除
              </el-button>
            </div>
          </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <!--分页-->
    <div class="pagination">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        background
        :current-page="curPage"
        :page-size="pageSize"
        layout="total, prev, pager, next, jumper"
        :total="totalDataNumber"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import PorductApi from '@/api/product.js';

export default {
  components: {},
  data() {
    return {
      /*切换菜单*/
      activeName: 'sell',
      /*切换选中值*/
      activeIndex: '0',
      /*是否正在加载*/
      loading: true,
      /*一页多少条*/
      pageSize: 15,
      /*一共多少条数据*/
      totalDataNumber: 0,
      /*当前是第几页*/
      curPage: 1,
      /*搜索参数*/
      searchForm: {
        productName: '',
        categoryId: ''
      },
      /*列表数据*/
      tableData: [],
      /*全部分类*/
      categoryList: [],
      productCount: {},
    };
  },
  created() {
    /*获取列表*/
    this.getData();
  },
  methods: {
    /*选择第几页*/
    handleCurrentChange(val) {
      let self = this;
      self.loading = true;
      self.curPage = val;
      self.getData();
    },

    /*每页多少条*/
    handleSizeChange(val) {
      this.pageSize = val;
      this.getData();
    },

    /*切换菜单*/
    handleClick(tab, event) {
      let self = this;
      self.curPage = 1;
      self.getData();
    },

    /*获取列表*/
    getData() {
      let self = this;
      let Params = self.searchForm;
      Params.pageIndex = self.curPage;
      Params.pageSize = self.pageSize;
      Params.type = self.activeName;
      self.loading = true;
      PorductApi.productList(Params, true)
        .then(res => {
          self.loading = false;
          self.tableData = res.data.productList.records;
          self.categoryList = res.data.categoryList;
          self.totalDataNumber = res.data.productList.total;
          self.productCount = res.data.productCount;
        })
        .catch(error => {
          self.loading = false;
        });
    },

    /*搜索查询*/
    onSubmit() {
      this.curPage = 1;
      this.getData();
    },

    /*打开添加*/
    addClick() {
      this.$router.push('/product/add');
    },

    /*打开编辑*/
    editClick(row) {
      console.log(row);
      this.$router.push({
        path: '/product/edit',
        query: {
          productId: row.id,
          scene: 'edit'
        }
      });
    },

    linkClick: function (val) {
      let self = this;
      let copyText = 'pages/product/detail/detail?productId=' + val;
      self.$copyText(copyText).then(function (e) {
        self.$message({
          message: '复制成功',
          type: 'success'
        });
      }, function (e) {
        self.$message({
          message: '复制失败',
          type: 'error'
        });
      })
    },
    /*打开复制*/
    copyClick(row) {
      this.$router.push({
        path: '/product/edit',
        query: {
          id: row.id,
          scene: 'copy'
        }
      });
    },
    /*删除*/
    delClick: function (row) {
      let self = this;
      let msg = '';
      if (row.productStatus == 30) {
        msg = '删除后不可恢复，确认删除该记录吗?';
      } else {
        msg = '删除后将移动到回收站，确定删除该记录吗?';
      }
      self
        .$confirm(msg, '提示', {
          type: 'warning'
        })
        .then(() => {
          PorductApi.delProduct({
            id: row.id
          }).then(data => {
            self.$message({
              message: '删除成功',
              type: 'success'
            });
            self.getData();
          });
        });
    },
    /*修改状态*/
    changeStatus(item, value) {
      let self = this;
      let msg = '';
      if (value == 10) {
        msg = '确认要上架该设备吗?';
      } else {
        msg = '确认要下架该设备吗?';
        if (self.activeName == 'recovery') {
          msg = '确认要移动该设备到仓库吗?';
        }
      }
      self.$confirm(msg, '提示', {
        type: 'warning'
      })
        .then(() => {
          PorductApi.changeStatus({
            productId: item.productId,
            state: value
          }).then(data => {
            self.$message({
              message: '操作成功',
              type: 'success'
            });
            self.getData();
          });
        });
    },
  }
};
</script>

<style lang="scss" scoped>
/* 状态样式 */
.payment-info-cell {
  padding: 5px 0;
}

.payment-tooltip {
  padding: 5px;
}

.payment-brief {
  display: flex;
  flex-direction: column;
}


</style>



// WEBPACK FOOTER //
// src/views/product/product/index.vue